export default {

	CUSTOM: "custom",

	TABS: {
		CUSTOMIZATION: "CUSTOMIZATION",
		PREVIEW: "PREVIEW",
		CODE: "CODE",
	},

	NOTICE_TYPES: {
		ERROR: 1,
		SUCCESS: 2,
	},

	BTN_COLORS: {
		BLUE: "blue",
		ORANGE: "orange",
	},

	FONTS: {
		"sans-serif": null,
		"'Fira Sans', sans-serif": "https://fonts.googleapis.com/css?family=Fira+Sans",
		"'Kalam', cursive": "https://fonts.googleapis.com/css?family=Kalam",
		"'Merriweather', serif": "https://fonts.googleapis.com/css?family=Merriweather",
		"'Poppins', sans-serif": "https://fonts.googleapis.com/css?family=Poppins",
		"'IBM Plex Sans', sans-serif": "https://fonts.googleapis.com/css?family=IBM+Plex+Sans",
		"'Space Mono', monospace": "https://fonts.googleapis.com/css?family=Space+Mono",
		"'Acme', sans-serif": "https://fonts.googleapis.com/css?family=Acme",
	},
};
